/*
  Hydrion WHITE: light colours for the UpCart drawer (colour-only overrides).
  UpCart renders inside an open shadow root on #upCart and applies the store-wide custom CSS saved in the
  UpCart app (dark). Page CSS cannot reach into the shadow root, so this theme-only script appends a light
  stylesheet as the LAST style inside it. It ships with this theme only, so the published theme and the app
  settings are untouched.
*/
(function () {
  var STYLE_ID = 'hy-upcart-light';
  var CSS = [
    /* Colours only: fonts, sizes, weights, radii and spacing stay exactly as the UpCart app renders them on the live theme. */
    ':host, .upcart-cart, [class*="CartPreview__card"] { background: #ffffff !important; color: #0a0f14 !important; }',
    '[class*="CartPreview__backdrop"] { background: rgba(10, 15, 20, 0.35) !important; }',
    '.upcart-cart { box-shadow: -1px 0 0 #e2e8f0 !important; }',

    /* header */
    '.upcart-public-header { color: #0a0f14 !important; }',
    '.upcart-public-header h3, .upcart-header-title, .upcart-title { color: #0a0f14 !important; }',
    '.upcart-public-header__close-button { background: #f5f8fa !important; color: #0a0f14 !important; }',
    '.upcart-public-header__close-button svg, .upcart-public-header__close-button path { color: #0a0f14 !important; fill: currentColor !important; stroke: currentColor !important; }',

    /* announcement (turquoise bar as on live) + rewards bar */
    '.upcart-public-announcement, .upcart-public-announcement *, .upcart-announcement { color: #0a0f14 !important; }',
    '.upcart-public-rewards, .upcart-public-rewards__message, .upcart-public-rewards__message * { color: #0a0f14 !important; }',
    '[class*="segmented-progress-bar__segment"]:not([class*="segment-fill"]):not([class*="segments-container"]) { background: #e2e8f0 !important; }',
    '[class*="segmented-progress-bar__segment-fill"] { background: #22d3ee !important; }',
    '[class*="segmented-progress-bar__milestone-icon"] { background: #e2e8f0 !important; color: #0891b2 !important; }',
    '[class*="segmented-progress-bar__milestone-icon"] svg, [class*="segmented-progress-bar__milestone-icon"] path { fill: #0891b2 !important; color: #0891b2 !important; }',
    /* live paints this untranslated label black on the black drawer, so it is not visible there; keep it unseen on white */
    '[class*="segmented-progress-bar__milestone-label"] { color: transparent !important; }',

    /* line items */
    '.upcart-public-component-product-tile, .upcart-public-component-product-tile * { color: #0a0f14; }',
    '[class*="product-tile__title-link"], [class*="product-tile__product-title"], .upcart-item-title, .upcart-line-item-title { color: #0a0f14 !important; }',
    '[class*="product-tile__price"]:not([class*="compare"]), .upcart-item-price, .upcart-line-item-price { color: #0a0f14 !important; }',
    '[class*="product-tile"] s, [class*="product-tile"] del, [class*="compare"], .upcart-item-compare-price { color: #64748b !important; }',
    '[class*="product-tile"] [class*="discount"], [class*="product-tile"] [class*="saving"], [class*="product-tile"] [class*="save"], .upcart-item-save { color: #dc2626 !important; }',
    '[class*="product-tile__variant"], [class*="product-tile__properties"], .upcart-item-variant { color: #64748b !important; }',
    '[class*="product-tile__remove-button"], [class*="product-tile__remove-button"] svg, [class*="product-tile__remove-button"] path { color: #64748b !important; fill: currentColor !important; }',
    '[class*="product-tile__quantity-selector"], .upcart-quantity, .upcart-item-quantity { background: #ffffff !important; border-color: #cbd5e1 !important; }',
    '[class*="product-tile__quantity-selector"] button, .upcart-quantity button { color: #0a0f14 !important; background: transparent !important; }',
    '[class*="product-tile__quantity-selector"] input, .upcart-quantity input { color: #0a0f14 !important; background: transparent !important; }',

    /* upsell carousel */
    '.upcart-cart [class*="upsell"] [class*="title"], .upcart-cart [class*="upsell"] [class*="title"] a, [class*="upsell-tile__title"], [class*="upsell-tile__title-link"] { color: #0a0f14 !important; }',
    '[class*="upsell-tile__price-row"], [class*="upsell-tile__price"]:not([class*="compare"]) { color: #0891b2 !important; }',
    '[class*="upsell-tile__price-compare-at"] { color: #64748b !important; }',
    '[class*="upsell-tile__variant-row"] { color: #64748b !important; }',
    '[class*="upsell-tile__image"], .upcart-cart [class*="upsell"] img[class*="upsell-tile__image"] { background: #f5f8fa !important; }',
    '.upcart-cart [class*="upsell"] button.upcart-public-component__button, .upcart-cart button[class*="component__button"], .upcart-public-component__button { color: #0a0f14 !important; }',
    '[class*="carousel__button"] svg, [class*="carousel__button"] path { fill: #0a0f14 !important; color: #0a0f14 !important; }',
    '.upcart-custom-html, .upcart-custom-html * { color: #0a0f14 !important; }',

    /* footer */
    '.upcart-footer, [class*="styles_Footer__"] { background: #ffffff !important; background-image: none !important; }',
    '.upcart-footer { border-top-color: #e2e8f0 !important; }',
    '[class*="cartSubtotalTitle"], [class*="cartSubtotalValue"] { color: #0a0f14 !important; }',
    '.upcart-checkout-button-container a, [class*="CustomButton__fullWidth"] { color: #0a0f14 !important; }',
    '.upcart-footer svg, .upcart-footer rect, .upcart-footer path { color: #64748b; }',
    '.upcart-footer [class*="trust"], .upcart-footer [class*="Trust"] { color: #64748b !important; }',
    /* inline-styled trust row (custom HTML): its 10% light-blue hairline vanishes on white, its #6b8494 labels are faint */
    'div[style*="border-top:1px solid rgba(125,211,252,0.1)"] { border-top-color: #e2e8f0 !important; }',
    'div[style*="color:#6b8494"] { color: #64748b !important; }'
  ].join('\n');

  function ensure(root) {
    if (!root) return;
    var el = root.getElementById ? root.getElementById(STYLE_ID) : root.querySelector('#' + STYLE_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = STYLE_ID;
      el.textContent = CSS;
    }
    if (root.lastChild !== el) root.appendChild(el);
  }

  function attach() {
    var host = document.getElementById('upCart');
    if (!host || !host.shadowRoot) return false;
    var root = host.shadowRoot;
    ensure(root);
    if (!root.__hyObserved) {
      root.__hyObserved = true;
      new MutationObserver(function () { ensure(root); }).observe(root, { childList: true });
    }
    return true;
  }

  var tries = 0;
  (function poll() {
    if (attach()) return;
    if (++tries < 240) setTimeout(poll, 250);
  })();
  document.addEventListener('click', function () { setTimeout(attach, 50); }, true);
})();
